import { snakeCase } from "text-snake-case";

export const decamelizeKeys = <T>(input: T): T => {
  if (input === null || input === undefined) {
    return input;
  }

  if (Array.isArray(input)) {
    return input.map(decamelizeKeys) as T;
  }

  if (typeof input === "object" && input.constructor === Object) {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [
        snakeCase(key),
        decamelizeKeys(value),
      ])
    ) as T;
  }

  return input;
};
